"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _actions = require("../../../../../actions");
var _style = require("./style");
var _dateutil = require("../../../../../helpers/dateutil");
var _IconFavoriteChat = _interopRequireDefault(require("../IconFavoriteChat"));
var _selectors = require("../../../../../selectors");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var StatusDate = function StatusDate(_ref) {
  var status = _ref.status,
    lastMessageAt = _ref.lastMessageAt,
    chat = _ref.chat,
    index = _ref.index,
    isChatTabsFavorite = _ref.isChatTabsFavorite,
    reloadChatList = _ref.reloadChatList;
  var date = (0, _dateutil.formatLastTimeOnlineChatListItem)(lastMessageAt, 'DD/MM/YY');
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.WrapperStatusDate, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.BubbleLeft, {
      children: [status, /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Bullet, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.WrapperDate, {
        children: date
      })]
    }), isChatTabsFavorite && /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.BubbleRight, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconFavoriteChat["default"], {
        chat: chat,
        index: index,
        reloadChatList: reloadChatList
      })
    })]
  });
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    isChatTabsFavorite: (0, _selectors.isChatTabsFavorite)(state)
  };
};
var _default = exports["default"] = (0, _actions.connect)(mapStateToProps)(StatusDate);